import React, { useContext, useEffect, useState } from "react";
import styles from "./SpecificInfosCab.module.scss";
import Axios from "../../../_services/caller.service";
import { useCabineContext } from "../../../context/CabineContext";
import { decodedB64, encodedB64 } from "../../../CustomHooks/DecodedBase64";
import {
  IoIosArrowDropdown,
  IoIosArrowDropup,
} from "react-icons/io";
import { FaPencilAlt } from "react-icons/fa";
import { FaExclamationTriangle } from "react-icons/fa";
import NavContext from "../../../context/NavContext";
import { FiCopy } from "react-icons/fi";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { PermissionGate } from "../managePermissions/PermissionGate";

const SpecificInfosCab = ({
  cabId,
  majCabine,
  setMajCabine,
}) => {
  const { cabine } = useCabineContext();
  const { ownerProfile } = useContext(NavContext);
  const [text, setText] = useState("");
  const [computerInfos, setComputerInfos] = useState("");
  const [edition, setEdition] = useState(false);
  const [newText, setNewText] = useState("");
  const [licenceDirac, setLicenceDirac] = useState(false);
  const [showAllUsersUseCab, setShowAllUSersUseCab] = useState(false);
  const [cabineUser, setCabineUser] = useState(false);
  const { t } = useTranslation();

  // GET CABINE NOTES
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/cabineNotes/${cabId}`)

        .then(function async(response) {
          const data = response.data.data[0].fval;
          if (data === "") {
            setText(data);
          } else {
            const decodedText = decodedB64(data);
            setText(decodedText);
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    }
  }, [cabId, cabine, majCabine]);

  // GET COMPUTER INFOS
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/computerInfos/${cabId}`)

        .then(function async(response) {
          const data = response.data.data;

          setComputerInfos(data);
        })
        .catch(function (error) {
          // console.log(error);
        });
    }
  }, [cabId, cabine, majCabine]);

  const handleChange = (event) => {
    setNewText(event.target.value);
  };
  //RETIRE LE'espace et le -
  const getPartBeforeDash = (str) => {
    // Découpe la chaîne au niveau du tiret et prend la première partie
    return str.split("-")[0].trim(); // trim() enlève les espaces avant et après
  };

  // GET DIRAC LICENCE
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/getLicenceDiracLoginMdp/${cabId}`)

        .then(function async(response) {
          const data = response.data.data;
          setLicenceDirac(data);
        })
        .catch(function (error) {
          // console.log(error);
        });
    }
  }, [cabId, cabine, majCabine]);

  // display user's role
  const displayRole = (role) => {
    if (role === 8) {
      return t("roles.calibration");
    }
    if (role === 1) {
      return t("roles.consultation");
    }
    if (role === 256) {
      return t("roles.admin");
    }
    if (role === 2147483647) {
      return t("roles.owner");
    }
  };
  // GET CABINE USERS
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/cabineUsers/${cabId}`)

        .then(function async(response) {
          const data = response.data.data;
          setCabineUser(data);
        })
        .catch(function (error) {
          // console.log(error);
        });
    }
  }, [cabId, cabine, majCabine]);

  const handleSubmit = (event) => {
    event.preventDefault();

    setText(newText);

    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        const textInB64 = encodedB64(newText);

        Axios.put(`/updateCabineNotes/${cabId}`, {
          data: textInB64,
        })

          .then((response) => {
            toast.success(t("superadmin_ui.data_saved"));
            setEdition(false);

            const data = response.data.data[0].fval;
            const textDecoded = decodedB64(data);
            setText(textDecoded);
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch((error) => {});
  };

  const handleEditClick = () => {
    setNewText(text);
    setEdition(true);
  };

  const handleCancelClick = () => {
    setEdition(false);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        toast(t("superadmin_ui.copied_clipboard"));
      },
      (err) => {
        console.error("Impossible de copier le texte : ", err);
      }
    );
  };

  const handleCopyEmail = (email) => {
    navigator.clipboard.writeText(email).then(
      () => {
        toast(t("superadmin_ui.email_copied_clipboard"));
      },
      (err) => {
        toast.error(t("superadmin_ui.email_copy_error"));
        console.error("Impossible de copier le texte : ", err);
      }
    );
  };

  const toggleShowUsers = () => {
    setShowAllUSersUseCab((prevShowAll) => !prevShowAll);
  };

  const cabineUserArray = Array.isArray(cabineUser) ? cabineUser : [];
  const visibleUsers = showAllUsersUseCab
    ? cabineUserArray
    : cabineUserArray.slice(0, 1);

  return (
    <>
      {/* NOTES */}
      <div className={styles.containerUsersAndSpecificNotes}>
        <h4 className={styles.sectionLabel}>{t("superadmin_ui.notes")}</h4>
        {edition && (
          <form className={styles.formArea} onSubmit={handleSubmit}>
            <textarea value={newText} onChange={handleChange} />
            <div className={styles.containerBtnValidation}>
              <button
                type="button"
                className={styles.btnCancel}
                onClick={handleCancelClick}
              >
                {t("common.cancel")}
              </button>
              <button
                type="submit"
                className={styles.btnValidate}
              >
                {t("common.validate")}
              </button>
            </div>
          </form>
        )}

        {!edition && (
          <div className={styles.containerText}>
            <h3>{text}</h3>
              <PermissionGate actionKey="cabines.notes">
            <FaPencilAlt
        
              onClick={handleEditClick}
              className={styles.editIcon}
              style={{ cursor: "pointer", fontSize: "20px", marginTop: "5px" }}
            /></PermissionGate>
          </div>
        )}
      </div>

      {/* INFOS DE LA CONFIGURATION DU PC  */}
      <div className={styles.containerConfigPCAndDirac}>
        <h4 className={styles.sectionLabel}>{t("superadmin_ui.pc_config")}</h4>
        <div className={styles.containerInfosDesktop}>
          {computerInfos && computerInfos.length > 0 ? (
            computerInfos.map((val) => (
              <div className={styles.infosComputer} key={val.fname}>
                <h3 className={styles.fnameComputer}>{val.fname}:</h3>
                <h3>{val.fval}</h3>
              </div>
            ))
          ) : (
            <div className={styles.noComputerInfos}>
              <h3>{t("superadmin_ui.no_pc_info")}</h3>
            </div>
          )}
        </div>

        {/* INFOS DE LA LICENCE DIRAC */}
        <h4 className={styles.sectionLabel}>{t("superadmin_ui.dirac_license")}</h4>
        {licenceDirac && licenceDirac.length > 0 ? (
          <>
            <div className={styles.containerInfosDirac}>
              {licenceDirac.map((licence, index) => (
                <div key={index} className={styles.infosDirac}>
                  <div className={styles.infos}>
                    <h3>{licence.Login}</h3>
                    <FiCopy
                      onClick={() => copyToClipboard(licence.Login)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <div className={styles.infos}>
                    <h3>{licence.mdp}</h3>
                    <FiCopy
                      onClick={() => copyToClipboard(licence.mdp)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              ))}
              {licenceDirac.length > 1 && (
                <div className={styles.warning}>
                  <FaExclamationTriangle
                    style={{ color: "red", fontSize: "25px" }}
                  />
                  {t("superadmin_ui.multiple_licenses_warning")}
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div className={styles.noLicenceDirac}>
              {t("superadmin_ui.no_dirac_license", { name: ownerProfile.display_name })}
            </div>
          </>
        )}
      </div>

      <div className={styles.containerUsersAndSpecificNotes}>
        {/* UTILISATEURS DE LA CABINE */}
        <h4 className={styles.sectionLabel}>{t("superadmin_ui.users_count", { count: cabineUserArray.length })}</h4>
        <div className={styles.usersGrid}>
          {visibleUsers.map((user) => (
            <div key={user.ID} className={styles.userCard}>
              <div className={styles.userCardTop}>
                <div className={styles.userAvatar}>
                  {user.display_name?.charAt(0)?.toUpperCase() || "?"}
                </div>
                <div className={styles.userInfo}>
                  <span className={styles.userName}>{user.display_name}</span>
                  <span className={styles.userEmail}>
                    {user.user_email}
                    <FiCopy
                      onClick={() => handleCopyEmail(user.user_email)}
                      style={{ cursor: "pointer" }}
                    />
                  </span>
                </div>
              </div>
              <span className={`${styles.roleBadge} ${styles[`role_${user.role}`] || ""}`}>
                {displayRole(user.role)}
              </span>
            </div>
          ))}
        </div>
        {cabineUserArray.length > 1 && (
          <button
            type="button"
            className={styles.showMoreBtn}
            onClick={toggleShowUsers}
          >
            {showAllUsersUseCab
              ? t("superadmin_ui.see_less")
              : t("superadmin_ui.see_all", { count: cabineUserArray.length })}
            {showAllUsersUseCab ? (
              <IoIosArrowDropup />
            ) : (
              <IoIosArrowDropdown />
            )}
          </button>
        )}
      </div>
    </>
  );
};

export default SpecificInfosCab;
